import React, {ChangeEvent, useRef, useState} from 'react';
import styles from '../Search.module.scss';
import SearchIcon from '../../../assets/icons/new_search.svg?react';

type Props = {
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
};

function Search(props: Props) {
  const { onChange, value, placeholder } = props;
  const [focused, setFocused] = useState(false);
  const search = useRef(null);

  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);
  const inFocus = () => {(search as any).current.focus()};
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

  return (
    <div className={styles.wrapper}>
        {!focused && <div className={styles.searchWrapper}>
        <SearchIcon className={styles.newSearchIcon} onClick={inFocus}/>
      </div>}
      <input ref={search} placeholder={placeholder? placeholder : 'Search'} onFocus={handleFocus} onBlur={handleBlur} className={styles.courseInput} type="text" value={value} onChange={handleChange}/>
    </div>
  );
}

export default Search;
